import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const MOUNTAIN =
  "M0 200 L70 110 L100 145 L150 60 L185 120 L230 30 L280 130 L320 90 L360 150 L400 70 L400 200 Z";

/**
 * Signature on-load moment: a navy curtain with a drawn gold ridge-line and the
 * wordmark, wiping upward to reveal the page. Fully animation-driven so it always
 * dismisses (no timers / storage that could get stuck).
 */
export const Intro = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  if (!show) return null;

  const finish = () => {
    document.body.style.overflow = "";
    setShow(false);
  };

  return (
    <motion.div
      data-testid="intro-overlay"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0E1B2E]"
      initial={{ y: 0 }}
      animate={{ y: "-100%" }}
      transition={{ duration: 0.85, ease: [0.76, 0, 0.24, 1], delay: 1.7 }}
      onAnimationComplete={finish}
    >
      <motion.svg viewBox="0 0 400 200" className="w-40 sm:w-56 h-auto" initial="hidden" animate="visible">
        <motion.path
          d={MOUNTAIN}
          fill="none"
          stroke="#C9A94A"
          strokeWidth="3"
          variants={{
            hidden: { pathLength: 0, opacity: 0 },
            visible: { pathLength: 1, opacity: 1, transition: { duration: 1.1, ease: "easeInOut" } },
          }}
        />
      </motion.svg>

      <motion.p
        className="mt-6 font-display text-2xl sm:text-3xl tracking-[0.2em] text-white"
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.75, duration: 0.5 }}
      >
        CK <span className="text-[#C9A94A]">&amp;</span> PARTNERS
      </motion.p>

      <motion.div
        className="mt-5 h-px w-40 sm:w-56 origin-left bg-[#C9A94A]/60"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ delay: 0.95, duration: 0.7, ease: "easeInOut" }}
      />
    </motion.div>
  );
};

export default Intro;
